import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar } from 'swiper';
import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function E() {
    const { useLang, Link, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('camp');
    const LISTS_CARDS: any = [
        {
            title: t('secE_list1_title'),
            products: [
                {
                    img: '/responsive/picture/common-products/river2.png',
                    title: t('secE_list1_card1_title'),
                    desc: t.rich('secE_list1_card1_desc', { m: (m: string) => <span className="m">{m}</span> }),
                    link: `https://${locale}.ecoflow.com/products/river-2-portable-power-station`,
                },
                {
                    img: '/responsive/picture/common-products/river2max.png',
                    title: t('secE_list1_card2_title'),
                    desc: t.rich('secE_list1_card2_desc', { m: (m: string) => <span className="m">{m}</span> }),
                    link: `https://${locale}.ecoflow.com/products/river-2-max-portable-power-station`,
                },
                {
                    img: '/responsive/picture/common-products/river2pro.png',
                    title: t('secE_list1_card3_title'),
                    desc: t.rich('secE_list1_card3_desc', {
                        m: (m: string) => <span className="m">{m}</span>,
                    }),
                    link: `https://${locale}.ecoflow.com/products/river-2-pro-portable-power-station`,
                },
            ],
        },
        {
            title: t('secE_list2_title'),
            products: [
                {
                    img: '/responsive/picture/common-products/delta2.png',
                    title: t('secE_list2_card1_title'),
                    desc: t.rich('secE_list2_card1_desc', { m: (m: string) => <span className="m">{m}</span> }),
                    link: `https://${locale}.ecoflow.com/products/delta-2-portable-power-station`,
                },
                {
                    img: '/responsive/picture/common-products/delta2max.png',
                    title: t('secE_list2_card2_title'),
                    desc: t.rich('secE_list2_card2_desc', { m: (m: string) => <span className="m">{m}</span> }),
                    link: `https://${locale}.ecoflow.com/products/delta-2-max-portable-power-station`,
                },
                {
                    img: '/responsive/picture/common-products/deltapro.png',
                    title: t('secE_list2_card3_title'),
                    desc: t.rich('secE_list2_card3_desc', { m: (m: string) => <span className="m">{m}</span> }),
                    link: `https://${locale}.ecoflow.com/products/delta-pro-portable-power-station`,
                },
            ],
        },
    ];
    return (
        <div id="camp-E" className={`camp-E camp-box ${css['camp-E']}`}>
            <h2 className="title">{t('secE_title')}</h2>
            <ul className="lists">
                {LISTS_CARDS?.map((cards: any, k: number) => (
                    <li className="list" key={k}>
                        <h3 className="list-title">{cards?.title}</h3>
                        <Swiper
                            className="cards"
                            modules={[Scrollbar]}
                            spaceBetween={20}
                            // centeredSlides={true}
                            slidesPerView={'auto'}
                            initialSlide={0}
                            scrollbar={{
                                hide: false,
                                draggable: true,
                                dragSize: 32,
                                snapOnRelease: true,
                            }}
                        >
                            {cards?.products?.map((card: any, m: number) => (
                                <SwiperSlide className={`card item-${k + 1}`} key={`${k}_${m}`}>
                                    <div className="card-img">
                                        <EFPicture src={card?.img} alt={card?.title} />
                                    </div>
                                    <p className="card-title">{card?.title}</p>
                                    <p className="card-desc">{card.desc}</p>
                                    <Link className="card-link" href={card?.link}>
                                        {t('secE_card_more')}
                                    </Link>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </li>
                ))}
            </ul>
        </div>
    );
}
